import React, { createContext, useState } from 'react';

import { getProjects } from '@/helpers/Requester';

// MissionTable 전역 상태 관리를 위한 Context
export const MissionTableContext = createContext();

// MissionTable 상태를 관리하는 Provider
export const MissionTableProvider = ({ onSelectProject, onSelectMission, showMissionEdit = false, children }) => {
  const [projects, setProjects] = useState(); // 프로젝트 내역
  const [selectedProjectId, setSelectedProjectId] = useState(); // 선택된 프로젝트 ID
  const [selectedMissionId, setSelectedMissionId] = useState(); // 선택된 미션 ID

  // 프로젝트 내역 조회
  const load = () => {
    getProjects().then(({ success, data }) => {
      setProjects(success ? data : []);
    });
  };

  // 프로젝트 선택
  const handleSelectProject = (project) => {
    // 외부 콜백 존재 시에만 호출
    if (onSelectProject) {
      onSelectProject(project);
    }

    if (project && onSelectProject) {
      setSelectedProjectId(project.id);
      setSelectedMissionId(null); // 미션 선택 해제
    }
  };

  // 미션 선택
  const handleSelectMission = (mission) => {
    // 외부 콜백 존재 시에만 호출
    if (onSelectMission) {
      onSelectMission(mission);
    }

    if (mission && onSelectMission) {
      setSelectedProjectId(null); // 프로젝트 선택 해제
      setSelectedMissionId(mission.id);
    }
  };

  // 프로젝트 이름 변경
  const handleRenameProject = (projectId, name) => {
    setProjects((prev) =>
      prev.map((project) => {
        if (project.id !== projectId) return project;

        return { ...project, name };
      }),
    );
  };

  // 프로젝트 삭제
  const handleDeleteProject = (projectId) => {
    setProjects((prev) => prev.filter(({ id }) => id !== projectId));
  };

  // 미션 삭제
  const handleDeleteMission = (missionId) => {
    setProjects((prev) =>
      prev.map((project) => ({
        ...project,
        missions: project.missions.filter(({ id }) => id !== missionId),
      })),
    );
  };

  // 선택 정보 초기화
  const clearSelection = () => {
    setSelectedProjectId(null);
    setSelectedMissionId(null);
  };

  // Context에 제공할 상태 및 함수
  const contextValue = {
    // 상태
    projects,
    selectedProjectId,
    selectedMissionId,
    showMissionEdit,
    // 함수
    load,
    clearSelection,
    handleSelectProject,
    handleSelectMission,
    handleRenameProject,
    handleDeleteProject,
    handleDeleteMission,
  };

  return <MissionTableContext.Provider value={contextValue}>{children}</MissionTableContext.Provider>;
};
